import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { patientQKeys } from "@hooks/queries/patient/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { PatientSurgicalHistoryItem } from "@customTypes/patient";


export const useCreateSurgicalRecord = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (data: PatientSurgicalHistoryItem) => {
      return api.post(`patient/surgical`, {
        patient_id: data.patientId,
        date: data.date,
        surgery_name: data.surgery,
      });
    },
    onSuccess: res => {
      // console.log(res);
      showSuccessNotification({
        title: "success",
        message: "create-surgical-record-success",
      });
      queryClient.invalidateQueries({
        queryKey: patientQKeys.surgery(res.data.patient_id),
      });
    },

    onError: (res: any) => {
      console.error("[From Create Surgical Record]", res);

      handleErrors(res, "mutation");
    },
  });
};
